<template>
  <div class="relative">
    <VDatePicker
      v-on:update:model-value="addFilter"
      v-model="date"
      locale="pt-BR"
      :first-day-of-week="2"
    >
      <template #default="{ togglePopover }">
        <span @click="togglePopover" class="filter-btn"
          ><calendar-icon :width="16" :height="16" />
          <p>Data</p>
        </span>
      </template>
    </VDatePicker>
  </div>
</template>

<script lang="ts">
import { startOfWeek, endOfWeek } from 'date-fns'
import CalendarIcon from '@/assets/icons/calendar.vue'
import { ref } from 'vue'
import { useStationStore } from '@/pinia-store/useStationStore'
import { useDashboardPeriod } from '@/modules/company/Dashboard/composables/useDashboardPeriod'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

export default {
  components: {
    CalendarIcon
  },
  setup() {
    const stationStore = useStationStore()
    const date = ref<string>(stationStore.listStationsQuery.startDate)

    // Dashboard V2: mantém o período atual (na Semana abre a semana da data; no Mês, o mês dela).
    const period = useFeatureFlags().flags.enabledDashboardV2 ? useDashboardPeriod() : null

    const addFilter = async (val: Date) => {
      if (period) {
        await period.goToDate(val)
        return
      }
      const dateStartOfWeek = startOfWeek(val, { weekStartsOn: 1 })
      const dateEndOfWeek = endOfWeek(val, { weekStartsOn: 1 })

      await stationStore.setDateFilter({
        startDate: dateStartOfWeek,
        endDate: dateEndOfWeek
      })
    }

    return {
      addFilter,
      date
    }
  }
}
</script>

<style>
.vc-popover-content-wrapper {
  z-index: 9999 !important;
}
/* Ajuste opcional para destacar os dias da semana se necessário */
.vc-weekday {
  text-transform: capitalize;
}
</style>
